import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label
} from 'reactstrap';
import Select from 'react-select';
import ReactLoading from 'react-loading';
import './ModalStyles.css';

class WithholdingModal extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'unset';
  }

  componentWillUnmount() {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'unset';
    document.body.style.paddingRight = '';
    
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
  }

  handleModalClosed = () => {
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '';
    }, 300);
  };

  render() {
    const {
      isOpen,
      toggle,
      selectedTevkifat,
      tevkifatOptions,
      showDeleteButton,
      tevLoading,
      tevDelLoading,
      totalWithholding,
      totalWithKdv,
      handleTevkifatChange,
      handleWithholdingSubmit,
      handleDeleteWithholding,
      code,
      formattedPrice
    } = this.props;

    return (
      <Modal 
        isOpen={isOpen} 
        toggle={toggle} 
        size="md"
        onClosed={this.handleModalClosed}
        backdrop="static"
        fade={true}
        centered
      >
        <ModalHeader 
          toggle={toggle}
          style={{
            background: '#f8f9fa',
            borderBottom: '2px solid #dee2e6',
            padding: '20px'
          }}
        >
          <h5 className="font-weight-bold text-cyan" style={{ margin: 0, fontSize: '16px' }}>
            <i className="fa fa-percent" style={{ marginRight: '10px' }}></i>
            Tevkifat İşlemleri
          </h5>
        </ModalHeader>
        
        <ModalBody style={{ padding: '20px', background: '#fff' }}>
          <Form id="withholding" onSubmit={handleWithholdingSubmit}>
            {/* Tevkifat Özeti */}
            <div style={{
              background: '#fff',
              padding: '20px',
              borderRadius: '8px',
              border: '2px solid #dee2e6',
              marginBottom: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{ 
                marginBottom: '15px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e9ecef'
              }}>
                <h6 className="font-weight-bold text-cyan" style={{ margin: 0, fontSize: '13px' }}>
                  <i className="fa fa-calculator" style={{ marginRight: '8px' }}></i>
                  Tevkifat Özeti
                </h6>
              </div>

              <div style={{ marginBottom: '10px' }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '10px 0',
                  borderBottom: '1px solid #f0f0f0',
                  fontSize: '13px'
                }}>
                  <span style={{ color: '#6c757d' }}>Tevkifat Tutarı</span>
                  <span style={{ fontWeight: '600', color: '#dc3545' }}>- {formattedPrice(totalWithholding)}</span>
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '10px 0',
                  fontSize: '13px'
                }}>
                  <span style={{ color: '#6c757d' }}>KDV Dahil Net Tutar</span>
                  <span style={{ fontWeight: '600', color: '#495057' }}>{formattedPrice(totalWithKdv)}</span>
                </div>
              </div>

              <div style={{
                background: '#007bff',
                padding: '12px',
                borderRadius: '6px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.9)', marginBottom: '3px', fontWeight: '600' }}>
                  GENEL TOPLAM
                </div>
                <div style={{ fontSize: '20px', fontWeight: '700', color: '#fff' }}>
                  {formattedPrice(totalWithKdv)}
                </div>
              </div>
            </div>

            {/* Tevkifat Seçimi */}
            <FormGroup>
              <Label for="withholding" className="font-weight-bold text-cyan">
                Tevkifat Tipi
              </Label>
              <Select
                isDisabled={!code}
                id="withholding"
                value={selectedTevkifat}
                onChange={handleTevkifatChange}
                options={tevkifatOptions}
                placeholder={code ? "Bir seçenek seçin" : "Paket yükseltme gerekli"}
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: '#ced4da',
                    borderWidth: '1px',
                    borderRadius: '6px',
                    minHeight: '44px',
                    fontSize: '14px',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#007bff'
                    }
                  })
                }}
              />
              {!code && (
                <small className="form-text text-danger" style={{ marginTop: '8px' }}>
                  <i className="fa fa-exclamation-triangle" style={{ marginRight: '5px' }}></i>
                  Tevkifat işlemlerini kullanabilmek için paket yükseltme gerekli!
                </small>
              )}
            </FormGroup>

            {/* Butonlar */}
            <div style={{ marginTop: '20px' }}>
              {tevLoading ? (
                <Button 
                  color="primary" 
                  block 
                  disabled 
                  style={{ 
                    padding: '12px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px'
                  }}
                >
                  <ReactLoading
                    type="spin"
                    width={'20px'}
                    height={'20px'}
                    color="#ffffff"
                  />
                  İşlem Yapılıyor...
                </Button>
              ) : tevDelLoading ? (
                <Button 
                  color="danger" 
                  block 
                  disabled 
                  style={{ 
                    padding: '12px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px'
                  }}
                >
                  <ReactLoading
                    type="spin"
                    width={'20px'}
                    height={'20px'}
                    color="#ffffff"
                  />
                  Siliniyor...
                </Button>
              ) : showDeleteButton ? (
                <Button
                  color="danger"
                  block
                  type="button"
                  disabled={!code}
                  onClick={handleDeleteWithholding}
                  style={{
                    padding: '12px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '6px'
                  }}
                >
                  <i className="fa fa-trash" style={{ marginRight: '8px' }}></i>
                  Tevkifatı Kaldır
                </Button>
              ) : (
                <Button
                  color="success"
                  block
                  type="submit"
                  disabled={!code || !selectedTevkifat}
                  style={{
                    padding: '12px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '6px'
                  }}
                >
                  <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
                  Tevkifat Ekle
                </Button>
              )}
            </div>
          </Form>
        </ModalBody>
        
        <ModalFooter style={{
          borderTop: '1px solid #dee2e6',
          background: '#f8f9fa',
          padding: '15px 20px'
        }}>
          <Button 
            color="secondary" 
            onClick={toggle}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '500',
              borderRadius: '6px'
            }}
          >
            <i className="fa fa-times" style={{ marginRight: '8px' }}></i>
            Kapat
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default WithholdingModal;

